import { gql } from '@apollo/client';
export default gql`
  query getWorkReport(
    $start: Date
    $end: Date
    $departmentId: String
    $employeeId: String
  ) {
    getWorkReport(
      start: $start
      end: $end
      departmentId: $departmentId
      employeeId: $employeeId
    ) {
      ok
      error
      count
      data {
        _id
        branch
        autoNo
        docNo

        opId
        opType
        opDocNo

        time

        isWorking
        isAbsent
        working
        absent
        isShift1
        isShift2

        bonosvalue
        bonosqty
        bonos
        overtimevalue
        overtimeqty
        overtime
        deductionvalue
        deductionqty
        deduction
        desc

        desc

        contractId
        contractName
        contractNameAr
        departmentId
        departmentName
        departmentNameAr
        employeeId
        employeeName
        employeeNameAr

        userId
        note

        createdAt
        updatedAt
      }
    }
  }
`;
